module.exports = __webpack_public_path__ + "static/media/employee.41e47dea.svg";